import styled from "styled-components";
import { ButtonSettings, Text, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
    props.theme.spacing.large};
  top: 4.5rem;
`;

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  padding: 0 3rem;
`;
export const TextStyled = styled(Text)`
  font-weight: normal;
  font-size: 0.928rem;
  margin-top: 1rem;
  color: #d1d3d4;
`;

export const BuyBrandsContainer = styled.div`
  display: flex;
  padding-top: 10rem;
  justify-content: space-between;
`;
export const FirstContainerStyle = styled.div`
  display: block;
  width: 31%;
`;
export const ImageStyle = styled.div`
  height: 12.577rem;
  width: 22.36rem;
  border-radius: 0.5rem;
  margin: 0 auto;
`;

export const DetailsContainerStyle = styled.div`
  width: 50%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  padding: 1rem;
`;

export const HeadingStyle = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
`;

export const ImageWrapper = styled.img`
  height: 8.125rem;
`;

export const PriceContainer = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && `width: 20%`}; /* only for ps4 */
  h1 {
    margin-top: 0rem;
  }
`;

export const HeadingStyled = styled(Heading)`
  font-size: 3rem;
`;
export const PriceStyled = styled(Heading)`
  font-size: 3rem;
`;

export const TextDetailsStyled = styled(Text)`
  font-size: 1.75rem;
  padding-top: 2rem;
  margin-bottom: 1.8rem;
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  width: 100%;
  margin-bottom: ${props => (props.userLocale === "ar" ? "0px" : props.theme.spacing.xsmall)};
  display: block;
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(4.125rem);
  height: calc(4.125rem);
  padding: ${props => props.theme.spacing.default} ${props => props.theme.spacing.xsmall};
  border: 3px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  color: ${props => props.theme.color.white};
  text-align: center;
  font-size: ${props => props.theme.font.size.large};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.8rem;
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: normal;
  display: inline-block;
  margin-bottom: 1.8rem;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  ${props => props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT && `width: 80%`}; /* only for ps4 */
`;

export const QrCodeStyle = styled.div`
  width: 20vw;
  height: 20vw;
  border: 1.25rem solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  // position: absolute;
  // top: calc(${props => props.theme.spacing.xlarge} * 4);
  // ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left: 7.3rem" : "right: 9.3rem")};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  margin-top: 9rem;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const QRCode = styled.img`
  width: 16rem;
  height: 16rem;
  border: 20px solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  // position: absolute;
  top: calc(7.5rem * 3);
  // ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left: 7.3rem" : "right: 6.3rem")};
  // text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};

`;

export const ButtonWrapper = styled.div``;

export const ButtonModalStyled = styled(ButtonSettings)`
  // display: block;
  // margin-top: ${props => props.theme.spacing.xsmall};
  width: 20.5%;
  // margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right: 70rem" : "left: 68rem")};
`;

export const ButtonModelWrapper = styled.div`
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
`;
